import i18n from "../i18n";
import { RelayGateApiConfiguration } from "../interfaces/api-configuration/api-endpoint-protocol-configuration";
import ValidationResult from "../interfaces/api/validation-result";

export const validateConfigName = (name: string | null, takenNames: string[] | null = null): ValidationResult[] => {
  const errors: ValidationResult[] = [];
  if (name == null || name.trim().length === 0) {
    errors.push({ isValid: false, error: i18n.t("validation-error-config-name-empty") });
  }
  if (name !== null && name.length > 80) {
    errors.push({ isValid: false, error: i18n.t("validation-error-config-name-too-long") });
  }

  const specialChars = /[`!@#$%^&*()+=[\]{};':"\\|,.<>/?~]/;
  if (name !== null && specialChars.test(name)) {
    errors.push({ isValid: false, error: i18n.t("validation-error-config-name-includes-special-chars") });
  }

  if (takenNames != null && takenNames.some((n) => n === name)) {
    errors.push({ isValid: false, error: i18n.t("validation-error-config-name-duplicate") });
  }
  return errors;
};

const validateRelayGateConfigs = (configs: RelayGateApiConfiguration[]): ValidationResult[] => {
  const errors: ValidationResult[] = [];

      // check for duplicate configs
      const normalize = (obj: Record<string, any>) =>
        JSON.stringify(
          Object.keys(obj)
            .sort()
            .reduce((acc, key) => {
              acc[key] = obj[key];
              return acc;
            }, {} as Record<string, any>)
          );
          
          const hasDuplicates =
            new Set(configs.map(normalize)).size !== configs.length;
          
          if (hasDuplicates){
            errors.push({isValid: false, error: i18n.t("validation-error-duplicate-configuration")})
          }

      // enforce unique Device Ids
      const hasDuplicateDeviceIds = new Set(configs.map(c => c.deviceId)).size !== configs.length;

      if (hasDuplicateDeviceIds){
        errors.push({ isValid: false, error: i18n.t("validation-error-duplicate-device-id")});
      }

      // validate all config names
      const nameValidationResults = configs.map(conf => validateConfigName(
        conf.name,
        configs
          .filter(c => c.id !== conf.id)
          .map(c => c.name)
        )
      );

      const uniqueNameValidationResults = [
        ...new Map(
          nameValidationResults
            .flat()
            .map(item => [JSON.stringify(item), item])
        ).values()
      ];
      errors.push(...uniqueNameValidationResults);

  return errors;
}

export default validateRelayGateConfigs;
